'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:gotoOrderDetail');
}

var _invoke = require('../invoke');

/**
 * 进入机票订单详情页面
 *
 * 点击后退时会返回订单列表页面，再后退会返回我的页面
 *
 * @memberof flight
 * @static
 * @name gotoOrderDetail
 * @param {String} url 订单页面地址
 * @param {String} orderListUrl 订单列表页面地址
 * @return {Undefined}
 * @example
 *  hbnb.flight.gotoOrderDetail(
 *      'url'
 *      'orderListUrl'
 *  );
 */
module.exports = function(url, orderListUrl) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url is %s', url);
        debug('orderListUrl is %s', orderListUrl);
    }

    _invoke('flight', 'goto_order_detail', {
        url: url,
        orderListUrl: orderListUrl
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/flight/goto-order-detail.js
// module id = 581
// module chunks = 0